import {Component, EventEmitter,ViewEncapsulation,Input,Output  } from '@angular/core';

@Component({
  selector: 'ngbd-modal-customclasssectiongroup',
  templateUrl: './modal-customclasssectiongroup.html'
})
export class NgbdModalCustomclasssectiongroup {
	@Input() activeFieldSectionGroupType;
	@Input() fieldTabArray;
	@Output() AddMoreOptionsFInsideTab = new EventEmitter();
	@Output() AddOptionsFieldInsideSectionsGroups = new EventEmitter();
	@Output() close_section_group_field = new EventEmitter();
  constructor() {
	
  }
  
  AddMoreOptionsFInside(h){
	this.AddMoreOptionsFInsideTab.emit(h);
  }
  AddOptionsFieldInsideSectionGroup(){
	this.AddOptionsFieldInsideSectionsGroups.emit();
  } 
  close_pop(){
	this.close_section_group_field.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/system_setting/DFB/template/create/modal-customclasssectiongroup.ts